import type { ExportBatch } from '~/shared/hooks/useExportFetch';
import type { Volume } from '~/shared/types/api';
import type { SelectOption } from '~/shared/utils/types';
import {
  downloadTabularExportBatch,
  ExportDownloadScheduler,
  generateExportFilename,
  volumeToExportRowCsv,
  volumeToExportRowJson,
} from '~/shared/utils/exportUtils';

export interface VolumesExportParams {
  countUrl: string;
  dataUrl: string;
  formats: Array<'csv' | 'json'>;
  filtersForName: SelectOption[];
}

interface VolumesExportDeps {
  fetchDataInBatches: (
    dataUrl: string,
    countUrl: string,
    responseKey?: string
  ) => AsyncGenerator<ExportBatch<Volume>>;
  activeTenantName: string | null | undefined;
}

export async function executeVolumesExport(
  { countUrl, dataUrl, formats, filtersForName }: VolumesExportParams,
  { fetchDataInBatches, activeTenantName }: VolumesExportDeps
): Promise<void> {
  const scheduler = new ExportDownloadScheduler();
  const baseFilename = generateExportFilename(
    activeTenantName || 'Account',
    'All_Volumes_Table',
    filtersForName,
    new Date()
  );

  for await (const { part, totalParts, data } of fetchDataInBatches(
    dataUrl,
    countUrl,
    'volumes'
  )) {
    await downloadTabularExportBatch({
      rows: data,
      baseFilename,
      formats,
      toCsvRow: volumeToExportRowCsv,
      toJsonRow: volumeToExportRowJson,
      part,
      totalParts,
      scheduler,
    });
  }
}
